import { gsap } from 'gsap';
export default function toggles() {
  const toggleBtns = $('.toggle-btn');
  const toggleCopy = $('.toggle-copy');

  const introReadMore = $('.introBlock__readMore');

  introReadMore.on('click', function () {
    let introId = $(this).attr('data-id');

    if ($(this).hasClass('introBlock__readMore--open')) {
      gsap.to('.introBlock__right--readMore[data-id=' + introId + ']', {
        height: '720px',
        duration: 0.5,
      });
      $(this).removeClass('introBlock__readMore--open');
    } else {
      $(this).addClass('introBlock__readMore--open');
      gsap.to('.introBlock__right--readMore[data-id=' + introId + ']', {
        height: 'auto',
        duration: 0.5,
      });
    }
  });
  // toggleBtns.on('click', (event) => {
  toggleBtns.each(function () {
    $(this).on('click', (e) => {
      e.preventDefault();
      let toggleId = $(this).attr('data-id');
      let btnToggle = $('.toggle-btn[data-id=' + toggleId + ']');
      let copyToggle = $('.toggle-copy[data-id=' + toggleId + ']');
      if (btnToggle.hasClass('active-btntoggle')) {
        toggleBtns.removeClass('active-btntoggle');
        toggleCopy.removeClass('active-toggle');
        btnToggle.removeClass('active-btntoggle');
        copyToggle.removeClass('active-toggle');
      } else {
        toggleBtns.removeClass('active-btntoggle');
        toggleCopy.removeClass('active-toggle');
        btnToggle.addClass('active-btntoggle');
        copyToggle.addClass('active-toggle');
      }
    });
  });
  // });
  // });
  // toggleBtns.on('click', (event) => {
  //   Array.prototype.forEach.call(toggleCopy, function (el) {
  //     if (el.dataset.id == event.target.dataset.id) {
  //       if (el.classList.contains('active-toggle')) {
  //         el.classList.remove('active-toggle');
  //       } else {
  //         el.classList.add('active-toggle');
  //       }
  //     } else {
  //       el.classList.remove('active-toggle');
  //     }
  //   });
  // });
}
